export default "__VITE_ASSET__7878850e__"